module.exports = __webpack_public_path__ + "lp/img/question_icon_sp@2x.7aa767fc.png";